import { apiClient } from "./client";

export interface TelemetryRaw {
  ts: string;
  source_id: string;
  metric: string;
  value: number | string | null;
  quality: string;
}

export interface TelemetryManualWrite {
  meter_id: string;
  ts: string; // ISO datetime
  metric: "heat_gcal" | "a_plus_kwh" | "a_minus_kwh";
  value: number;
}

export interface LiveTelemetryView {
  now: string;
  hour_start: string;
  fact_power_kw: number | string | null;
  self_needs_kw: number | string | null;
  gas_m3h: number | string | null;
  had_warning: boolean;
  had_alarm: boolean;
  elapsed_min: number;
  rdn_fact_so_far_kwh: number | string | null;
  rdn_plan_hour_kwh: number | string | null;
  projected_hour_kwh: number | string | null;
  deviation_kwh: number | string | null;
  deviation_pct: number | string | null;
  had_alarm_today: boolean;
  plan_submitted_at: string | null;
}

export const telemetryApi = {
  live: () => apiClient.get<LiveTelemetryView>("/telemetry/live").then((r) => r.data),

  putManual: (body: TelemetryManualWrite) =>
    apiClient.put<TelemetryRaw>("/telemetry/manual", body).then((r) => r.data),

  byMeter: (meterId: string, date?: string) =>
    apiClient
      .get<TelemetryRaw[]>(`/telemetry/by-meter/${meterId}`, {
        params: date ? { on_date: date } : undefined,
      })
      .then((r) => r.data),
};
